import { ProjectView } from "~/backendApis/viewModel"

export const projectListLogic = (currentProjects: ProjectView[]) => ({
  append: (newProjects: ProjectView[]): ProjectView[] => {
    const allProjects = [...currentProjects, ...newProjects]

    // idをキーに重複を除外
    const refinedProjects = allProjects.reduce(
      (sum: ProjectView[], project: ProjectView) => {
        if (sum.every((p: ProjectView) => p.id !== project.id)) {
          sum.push(project)
        }
        return sum
      },
      []
    )

    return refinedProjects
  },
})
